<template>
  <div :class="['chart',mode]">
    <!-- 参考RatioChart -->
    <div class="title1">股东人数</div>

    <div v-show="price && price.length > 0">
            <div class="legend color63">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                    <circle cx="4" cy="4.50006" r="4" fill="#7BB4FB"/>
                    </svg>
                    <i>股东户数 (万户)</i>
                </span>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                    <circle cx="4" cy="4.50006" r="4" fill="#FFA056"/>
                    </svg>
                    <i>股价 (元)</i>
                </span>
            </div>
            <div class="ratio_chart">
                <div id="ratio_chart"></div>
            </div>
    </div>

    <empty v-show="!price || (price&& price.length == 0)"></empty>
    
  </div>
</template>

<script>
import * as echarts from 'echarts';
import empty from './empty.vue';
export default {
    components:{empty},
    data(){
        return{
            mode:this.$route.params.mode,//light,dark
            code:this.$route.params.code,//sz000070
        }
    },
    created() {
        console.log(this.$route.params);
    },
    props:{
        price:{
            type:Array,
        },
        ratio:{
            type:Array,
        },
    },
    mounted(){
        //this.ratio_chart();
    },
    watch:{
        price:{
            handler(val, oldVal){
                if(val){
                    this.ratio_chart();
                }
            },
            deep:true //true 深度监听
        }
    },
    methods:{
        ratio_chart(){
            var price = this.price;
            var ratio = this.ratio;
            function fontSize(res){
                let docEl = document.documentElement,
                    clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
                if (!clientWidth) return;
                let fontSize = (clientWidth / 750);
                return res*fontSize;

            }

            var color63 = '#636363',
                color33 = '#333',
                colorDC = '#DCDCDC';
            if(this.mode == 'dark'){
                color63 = '#B7B7B7';
                color33 = '#F3F3F3';
                colorDC = 'rgba(220, 220, 220, 0.35)';
            }

            //分离数据
            function splitData(rawData) {
                var time = [];
                var values = []
                for (var i = 0; i < rawData.length; i++) {
                    time.push(time_format(rawData[i].x));
                    values.push(rawData[i].y.toFixed(2))
                }
                return {
                    time: time,
                    values: values
                };
            }
            //格式化时间
            function time_format(time) {
                var t0 = time.split(' ')[0];
                return t0
            }
            //取价格的max,min,range

            var max_price1 = Math.ceil(Math.max(...splitData(price).values));
            var max_price = Math.ceil(Math.max(...splitData(ratio).values));

            //var max_price = Math.ceil(Math.max(max_price1,max_price2));
            //var min_price = Math.floor(Math.min(...splitData(price).values));

            var min_price = 0

            var range =Math.ceil(((max_price-min_price)/6));
            var range1 =Math.ceil(((max_price1-min_price)/6));

            //max_price 离 range 比较远的时候 选 max_price

             max_price = (((range*6) - max_price)/range) > 0.5 ? max_price : (range*6);
             max_price1 = (((range1*6) - max_price1)/range1) > 0.5 ? max_price1 : (range1*6);

            //min_price = max_price - range*4;


            //console.log(max_price,min_price,range)
            //绘制图表
            var myChart = echarts.init(document.getElementById('ratio_chart'));
            var option = {
                grid:{
                    x:60,
                    y:45,
                    x2:40,
                    y2:90
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle: {
                            color: color33,	//显示竖线颜色
                            type:'solid',
                        }
                    },
                    textStyle: {
                        color: '#F3F3F3',
                        fontSize:fontSize(22),
                    },
                    backgroundColor:'rgba(0, 0, 0, 0.80)',	//tooltip背景色
                    //borderColor:'#FFA391',		//tooltip边框颜色
                    borderWidth:0,
                    padding:0,
                    formatter: function (param) {	//自定义tooltip内容
                        var text = '';
                        console.log(param)
                        text += '<div class="tooltip">' +
                            '<div>'+param[0].name+'</div>' +
                            '<div>'+param[0].seriesName+'：<span>'+param[0].data+'万户</span></div>' +
                            '<div>'+param[1].seriesName+'：<span>'+param[1].data+'元'+'</span></div>' +
                            '</div>'
                        return text;
                    }
                },
                xAxis: [
                    {
                        type: 'category',
                        data: splitData(ratio).time,
                        axisLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: '#979797',//左边线的颜色
                                width:'1'//坐标线的宽度
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: color63,//坐标值得具体的颜色
                                fontSize: fontSize(22),
                            },
                            margin: 15, // 刻度标签与轴线之间的距离
                            formatter: function (value) {
                                let arr = value.split('-');
                                let year = arr[0],
                                    month = arr[1],
                                    day = arr[2];
                                let val = `${month}-${day}\n${year}`;
                                return val;
                            },
                            // width:fontSize(80),
                            // overflow: "break",
                        },
                        axisTick: {    // 坐标轴 刻度
                            show: false,  // 是否显示
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        min: 0,
                        max: max_price,
                        interval: range,
                        axisLabel: {
                            formatter: '{value} ',
                            textStyle: {
                                color: color63,//坐标值得具体的颜色
                                fontSize: fontSize(22),
                            },
                            margin: 1, // 刻度标签与轴线之间的距离
                        },
                        //网格样式
                        splitLine: {
                            show: true,
                            lineStyle:{
                                color: colorDC,
                                width: 1.5,
                                type: 'dashed'
                            }
                        }
                    },
                    {
                        type: 'value',
                        min: 0,
                        max: max_price1,
                        interval: range1,
                        axisLabel: {
                            show: false,
                        },
                        //网格样式
                        splitLine: {
                            show: false,
                        }
                    }
                ],
                series: [

                    {
                        name: '股东户数',
                        type: 'bar',
                        data: splitData(ratio).values,
                        itemStyle: {    // 图形的形状
                            color: '#7BB4FB',
                        },
                        barWidth: 44,  // 柱形的宽度
                        label: {
                            show: true,
                            color: '#7BB4FB',
                            fontSize:fontSize(20),
                            position: "top",
                        }
                    },
                    {
                        name: '股价',
                        type: 'line',
                        yAxisIndex: 1,
                        data: splitData(price).values,
                        color: "#FFA056",//拐点样式
                        symbol:'emptyCircle',
                        symbolSize:16,
                        itemStyle: {    // 图形的形状
                            normal: {
                                lineStyle:{
                                    width:3,  // 设置线宽
                                    type:'solid'  //'dotted'虚线 'solid'实线
                                },
                            },
                            emphasis: {          //突出效果配置(鼠标置于拐点上时)
                                borderWidth: 5,         //  拐点边框宽度
                            },
                        },
                    }
                ]
            };
            myChart.setOption(option);
        },
    }
}
</script>

<style lang="scss" scope>
  @import "~@/assets/sass/globalapp.scss";
  .tooltip{
    line-height: 150%;
    border-radius: rem2(8px);
    padding: rem2(8px);
  }

  .chart{
    .title1{
        padding: rem2(15px) rem2(12px);
    }
    .legend{
        margin-bottom: rem2(5px);
        >span{
            margin-left: rem2(15px);
            >svg{
                width: rem2(8px);
                height: rem2(8px);
            }
            >i{
                font-size: rem2(12px);
                margin-left: rem2(5px);
                font-style: normal;
            }
        }
    }
    .ratio_chart{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        #ratio_chart{
            width: rem2(351px);
            height: rem2(200px);
        }


    }
  }
  




</style>